import { render, staticRenderFns } from "./design-project.vue?vue&type=template&id=1cc6d516&scoped=true"
import script from "./design-project.vue?vue&type=script&lang=js"
export * from "./design-project.vue?vue&type=script&lang=js"
import style0 from "./design-project.vue?vue&type=style&index=0&id=1cc6d516&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc6d516",
  null
  
)

export default component.exports